module.exports = __webpack_public_path__ + "img/folder.8eb656ee.png";